import type { RefObject } from "react";
import { useEffect, useState } from "react";

export function useIsHovered(element: RefObject<HTMLElement> | HTMLElement | null) {
    const [isHovered, setIsHovered] = useState(false);

    useOnIsHoveredChanged(element, setIsHovered);

    return isHovered;
}

export function useOnIsHoveredChanged(element: RefObject<HTMLElement> | HTMLElement | null, onIsHoveredChanged: ((isHovered: boolean) => void) | undefined) {
    useEffect(() => {
        const container = element && "current" in element ? element.current : element;

        if (container && onIsHoveredChanged) {
            const onMouseMove = (e: MouseEvent) => {
                if (!e.composedPath().includes(container)) {
                    onIsHoveredChanged(false);
                    document.removeEventListener("mousemove", onMouseMove);
                }
            };

            const onMouseEnter = () => {
                document.addEventListener("mousemove", onMouseMove);
                onIsHoveredChanged(true);
            };

            const onMouseLeave = () => onIsHoveredChanged(false);

            container.addEventListener("mouseenter", onMouseEnter);
            container.addEventListener("mouseleave", onMouseLeave);

            return () => {
                container.removeEventListener("mouseenter", onMouseEnter);
                container.removeEventListener("mouseleave", onMouseLeave);
                document.removeEventListener("mousemove", onMouseMove);
            };
        }
    }, [onIsHoveredChanged, element]);
}
